import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading, SecondaryButton } from './ui/UI';
export function FrontierGatewayTeaser() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-645">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-646">
        <SectionLabel number="NEW" label="Frontier Gateway" className="mb-8" data-id="element-647" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-648">
          <div className="lg:col-span-7" data-id="element-649">
            <SectionHeading size="xl" data-id="element-650">
              Frontier cyber models
              <br data-id="element-651" />
              <span className="text-white/40" data-id="element-652">need guardrails.</span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-5 lg:pt-4" data-id="element-653">
            <p className="text-lg text-white/60 leading-relaxed mb-6" data-id="element-654">
              Periscan lets enterprises use powerful security models without
              giving them direct access to the network. The model thinks.
              Periscan controls. Evidence proves.
            </p>
            <SecondaryButton href="/frontier-gateway" size="md" data-id="element-655">
              Explore Frontier Gateway
            </SecondaryButton>
          </div>
        </div>

        <div className="border-t border-white/5" data-id="element-656">
          {[{
          title: 'No Direct Access',
          desc: 'Models never touch your network directly. All interaction goes through typed, policy-controlled Periscan tools.'
        }, {
          title: 'Strict Policy Control',
          desc: 'Periscan enforces scope, tools, approvals, redaction, execution, and audit on every model request.'
        }, {
          title: 'Evidence-Backed',
          desc: 'No black-box security work. Every model-driven action produces real, auditable evidence.'
        }].map((feature, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: i * 0.05
        }} className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-6 border-b border-white/5 last:border-0" data-id="element-657">
              <div className="md:col-span-1" data-id="element-658">
                <span className="font-mono text-xs text-[#1a8fd4]/60" data-id="element-659">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>
              <div className="md:col-span-4" data-id="element-660">
                <h3 className="text-lg font-semibold text-white tracking-tight" data-id="element-661">
                  {feature.title}
                </h3>
              </div>
              <div className="md:col-span-7" data-id="element-662">
                <p className="text-base text-white/60 leading-relaxed" data-id="element-663">
                  {feature.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}